import { format, isValid, parseISO } from 'date-fns'

type CurrencyDisplay = 'symbol' | 'code' | 'name' | undefined
type Style = 'decimal' | 'currency' | 'percent' | 'unit' | undefined

export const formatAmount = (amount: number) =>
  new Intl.NumberFormat('es-GT', {
    style: 'decimal',
    minimumFractionDigits: 2
  }).format(amount)

export const formatAmountWithCurrency = (
  amount: number,
  currency: string,
  symbol: CurrencyDisplay = 'symbol',
  style: Style = 'decimal'
) =>
  new Intl.NumberFormat('es-GT', {
    style,
    minimumFractionDigits: 2,
    currency,
    currencyDisplay: symbol
  }).format(amount)

export const formatDate = (dateString: string) =>
  isValid(parseISO(dateString)) ? format(parseISO(dateString), 'dd/MM/yyyy') : ''
